var render = function render(){var _vm=this,_c=_vm._self._c;return _c('complaints-personal-form',{ref:"complaints-personal-form"})
}
var staticRenderFns = []

export { render, staticRenderFns }